import React from 'react';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import StorageIcon from '@mui/icons-material/Storage';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { dsVar, ink } from '../theme/tokens';

/**
 * Compact affordance shown inside the node edit drawer when the activity
 * template reports has_integration_binding. Shared by AgentFlowEditor and
 * TaskFlowEditor so the two drawers cannot drift apart.
 */
const IntegrationBindingCard = ({ alias, accent = '#FFDE59', onOpen }) => (
  <Box sx={{ mb: 4 }}>
    <Typography
      sx={{
        color: dsVar('fg-2'),
        fontSize: '10px',
        fontWeight: 600,
        fontFamily: "'JetBrains Mono', monospace",
        textTransform: 'uppercase',
        letterSpacing: '-0.02em',
        mb: 1,
      }}
    >
      Connected Data Source
    </Typography>
    <Box
      onClick={onOpen}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        padding: '12px 14px',
        backgroundColor: dsVar('raised'),
        border: `1px solid ${dsVar('line')}`,
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'border-color 0.2s ease, background-color 0.2s ease',
        '&:hover': { borderColor: accent, backgroundColor: dsVar('raised') },
      }}
    >
      <Box
        sx={{
          color: ink(accent),
          backgroundColor: `${accent}22`,
          borderRadius: '6px',
          padding: '6px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <StorageIcon sx={{ fontSize: 18 }} />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          sx={{
            color: accent,
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: '13px',
            fontWeight: 600,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
          title={alias}
        >
          {alias}
        </Typography>
        <Typography sx={{ color: dsVar('fg-2'), fontSize: '11px' }}>Data source binding</Typography>
      </Box>
      <Tooltip title="View data source">
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onOpen?.();
          }}
          sx={{ color: dsVar('fg-2'), '&:hover': { color: accent } }}
        >
          <OpenInNewIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Tooltip>
    </Box>
  </Box>
);

export default IntegrationBindingCard;
